import { endOfDay } from "date-fns";
import { useMemo } from "react";

import type { CompleteDateRange } from "@/components/StructuredSearch/stores/structured-search/structured-search-store";

export interface PromptVersionLogsDateRangeConfig {
  initialDateRange: CompleteDateRange;
}

interface UsePromptVersionLogsDateRangeConfigInput {
  promptVersion?: {
    created_at: string;
  };
}

/** Initial request-logs range starts at the version's creation time with no version-to-version max bound. */
export const usePromptVersionLogsDateRangeConfig = ({
  promptVersion,
}: UsePromptVersionLogsDateRangeConfigInput): PromptVersionLogsDateRangeConfig | undefined =>
  useMemo(() => {
    if (!promptVersion) {
      return undefined;
    }

    return {
      initialDateRange: {
        from: new Date(promptVersion.created_at),
        to: endOfDay(new Date()),
      },
    };
  }, [promptVersion]);
